export enum ParagraphSize {
  tiny = 'tiny',
  small = 'small',
  base = 'base',
}

export enum ParagraphStyle {
  normal = 'normal',
  tall = 'tall',
}
